<template>
  <div class="sp-template">
    <!-- 从订单预警页面复制 alarm_order.vue -->
    <div class="h-title">供应商账单</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">

        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">

          <el-row>
            <el-form-item label="账单号">
              <el-input type="textarea" v-model="conditions.idText" placeholder="多个供应商账单号用回车分割"></el-input>
            </el-form-item>

            <el-form-item label="创建时间">
              <el-date-picker
              v-model.lazy="daterange1"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"                
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="付款时间">
              <el-date-picker
              v-model.lazy="daterange2"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"                
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>

          <!-- </el-row>
          <el-row> -->
            <el-form-item label="供应商">
              <el-select v-model="conditions.supplierId" filterable clearable>
                <el-option v-for="item in suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>


            <el-form-item>
              <div class="search-form__buttons">
                <el-button type="primary" size="small" @click="searchTask">搜 索</el-button>
              </div>
            </el-form-item>

          </el-row>
          <!-- <el-row></el-row> -->

        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="searchTask">
          <el-tab-pane label="未付款" name="0"></el-tab-pane>
          <el-tab-pane label="已付款" name="1"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
          <el-button size="small" @click="popBatchPay()" v-if="in_configs(90203)" v-show="conditions.status==0">付款</el-button>

          <!-- <el-button size="small" @click="exportAll()">导出</el-button> -->
        </div>
      </div>
      <el-table :data="tableData" stripe border  style="width: 100%"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>

        <!-- <el-table-column prop="id" label="id"></el-table-column> -->
        <el-table-column prop="id" label="供应商账单号"></el-table-column>

        <el-table-column label="供应商">
          <template slot-scope="scope" >
						{{supplierMap[scope.row.supplierId] == null ? scope.row.supplierId : supplierMap[scope.row.supplierId]}}
					</template>
        </el-table-column>
        <el-table-column prop="amount" label="金额"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="createdAt" label="创建时间"></el-table-column>
        <el-table-column prop="payTime" label="付款时间"></el-table-column>

        <el-table-column label="操作" v-if="conditions.status==0 ">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="popPay(scope.row)"  v-if="in_configs(90203)" > 付款</el-button>
            <el-button type="text" size="mini" @click="deleteData(scope.row)"  v-if="in_configs(90204)" > 删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="conditions.currentPage" :page-size.sync="conditions.pageSize" :page-sizes="[5, 10, 50, 100, 500, 2000, 10000]" 
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

  
    <el-dialog title="付款" :visible.sync="dialogEditVisible" width="400px">
      <el-form size="small" label-width="100px">

        <el-form-item label="付款时间">
          <el-date-picker v-model="editData.payTime" type="datetime" :clearable="true" value-format="yyyy-MM-dd HH:mm:ss" placeholder="付款时间"></el-date-picker>
        </el-form-item>

        <el-form-item label="备注">
          <el-input type="textarea" v-model.lazy="editData.remarks"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogEditVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="editSubmit()">确 定</el-button>
      </div>
    </el-dialog>

  </div>




</template>

<script>
  import { mapState, mapMutations } from "vuex";
  import {pickerOptions} from "../../util/formUtil";
  export default {
    data() {
      return {
        suppliers: [],
        supplierMap: {},
        pickerOptions: pickerOptions,
        typemaps: {"1":"亏损","2":"退件","3":"拒收","4":"破损","5":"恶劣天气","6":"派送延误","7":"超时提取","8":"超时签收"},
        statuslist: [{"id":0,"name": "待客服处理"},{"id":1,"name": "待操作处理"},{"id":2,"name": "已处理"}],

        sumbitForm: {
          categoryId: "",
          kindId: "",
          supplierId: ""
        },
        dialogCheckVisible: false,
        tableData: [],
        multipleSelection: [],

        daterange1: "",
        daterange2: "",
        conditions: {
          ids: [],
          idText: '',
          supplierId: "",

          startDate: "",
          endDate: "",
          payTimeStart: "",
          payTimeEnd: "",
          
          status: 0,
          currentPage: 1,
          pageSize: 5,
          export: 0
          
        },

        dialogEditVisible: false,
        editData: {
          "ids": [],
          "payTime": "",
          "remarks": ""
        },
        total: 0
      };
    },
    components: {},
    created() {
      let _this = this;
      setTimeout(async () => {

        await _this.querySupplier()
        _this.searchTask()

      }, 1000);

    },
    methods: {
      ...mapMutations([
        "setManualTrackingNumbers",
        "setOrderListTable",
        "setOrderListConditions",
        "setOrderListSearchMore"
      ]),
      // 供应商名称
      querySupplier() {
        this.$request1({
          method: 'get',
          url: '/supplier'
        }).then(response => {
            this.suppliers = response.data;
            if (this.suppliers != null && this.suppliers.length > 0) {
              this.suppliers.forEach(item => {
                this.supplierMap[item.id] = item.name;
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      formatRefNumber(refNumber) {
        let arr = refNumber;
        arr.forEach((item, index) => {
          if (item === " " || item === ",") {
            arr.splice(index, 1);
          }
        });
        return arr;
      },
     
      searchTask() {
        this.conditions.currentPage = 1;
        this.query();
      },
      query() {
        let _this = this;

        this.conditions.ids = [];
        if (this.conditions.idText) {
          this.conditions.ids = this.conditions.idText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
        }
        this.conditions.startDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[0] : ""
        this.conditions.endDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[1] : ""
        this.conditions.payTimeStart = this.daterange2 && this.daterange2.length==2 ? this.daterange2[0] : ""
        this.conditions.payTimeEnd = this.daterange2 && this.daterange2.length==2 ? this.daterange2[1] : ""

        this.conditions.export = 0

        this.$request1({
          method: 'post',
          url: '/supplier-invoice/query-supplier-invoice',
          data: _this.conditions,
          withCredentials: true,
          header: {
            'Content-Type': 'application/json'
          }
        })
          .then(response => {
            // console.log(response)
            if (response.data.success) {
              _this.tableData = response.data.data;
              _this.total = response.data.total;
              
            } else {
              _this.$message.error(response.data.message);
            }
          })
          .catch(error => {
            console.log(error);
          });
      },
      // 批量付款
      popBatchPay() {
        let _this = this
        let t = '付款'
        // console.log(this.multipleSelection.length);
        if (this.multipleSelection.length == 0) {
          this.$message.error(`请勾选要${t}的数据`);
          return;
        }
        this.dialogEditVisible = true;
        this.editData.remarks = ""
        this.editData.ids = this.multipleSelection.map(a => a.id).filter(a => a)
      },

      popPay(row) {
        this.dialogEditVisible = true;

        this.editData.ids = [row.id]
        this.editData.remarks = row.remarks

      },
      editSubmit() {
        let _this = this;

        if(!this.editData.payTime){
          this.$message.error('付款时间不能为空')
          return
        }

        this.$request1
          .post(
            '/supplier-invoice/update-supplier-invoice',
            _this.editData,
            {
              withCredentials: true,
              headers: {
                "content-type": "application/json"
              }
            }
          )
          .then(function (response) {
            if (response.data.success) {
              _this.$message.success("提交成功");
              _this.dialogEditVisible = false
              _this.query();

            } else {
              _this.$message.error(response.data.message);
            }
          });

      },
      deleteData(row){
        let _this = this;
        this.$confirm("是否确定删除账单："+ row.id +" ？", "警告", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
              
              this.$request1
                .post(
                  '/supplier-invoice/delete-supplier-invoice',
                  {
                    ids: [row.id]
                  },
                  {
                    withCredentials: true,
                    headers: {
                      "content-type": "application/json"
                    }
                  }
                )
                .then(function (response) {
                  if (response.data.success) {
                    _this.$message.success("删除成功");
                    _this.query();

                  } else {
                    _this.$message.error(response.data.message);
                  }
                });
              
          }) 
      },
      exportAll() {
        let _this = this;

        var url = tmsSpringUrl + '/alarm/query';

        var form = document.createElement("form");
        form.method = "post";
        form.action = url;
        form.target = "_blank";
        document.body.appendChild(form);


        if (this.conditions.orderIdText) {
          let orderIds = this.conditions.orderIdText.split(/\n+/gim).map(a => a.trim()).filter(a => a);
          orderIds.forEach(a => {
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = "orderIds[]";
            input.value = a;
            form.appendChild(input);
          })
        }
        this.conditions.export = 1
        this.conditions.startDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[0] : ""
        this.conditions.endDate = this.daterange1 && this.daterange1.length==2 ? this.daterange1[1] : ""
        
        Object.keys(this.conditions).forEach(key => {
          if(key != 'orderIds' ){
            var input1 = document.createElement("input");
            input1.type = "hidden";
            input1.name = key;
            input1.value = this.conditions[key];
            form.appendChild(input1);
          }
        })

        var input2 = document.createElement("input");
      input2.type = "hidden";
      input2.name = "token";
      input2.value = this.$getToken()
      form.appendChild(input2);

        form.submit();

      },

      //多选按钮
      handleSelectionChange(val) {
        // console.log(">>>val=", val);
        this.multipleSelection = val;
      },
      //分页
      handleSizeChange(val) {
        this.conditions.currentPage = 1;
        this.conditions.pageSize = val;
        this.query();
      },
      handleCurrentChange(val) {
        this.conditions.currentPage = val;
        this.query();
      },
      dateFormat(date, fmt) {
        var o = {
          "M+": date.getMonth() + 1, //月份
          "d+": date.getDate(), //日
          "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
          "H+": date.getHours(), //小时
          "m+": date.getMinutes(), //分
          "s+": date.getSeconds(), //秒
          "q+": Math.floor((date.getMonth() + 3) / 3), //季度
          S: date.getMilliseconds() //毫秒
        };
        var week = {
          "0": "/u65e5",
          "1": "/u4e00",
          "2": "/u4e8c",
          "3": "/u4e09",
          "4": "/u56db",
          "5": "/u4e94",
          "6": "/u516d"
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        if (/(E+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (RegExp.$1.length > 1
              ? RegExp.$1.length > 2
                ? "/u661f/u671f"
                : "/u5468"
              : "") + week[date.getDay() + ""]
          );
        }
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
          }
        }
        return fmt;
      }
    }
  };
</script>

<style >
  .el-message-box__message p {
    margin: 0;
    line-height: 24px;
    white-space: pre-wrap !important;
  }

  .el-range-separator{
    width: 20px !important;
    font-size: 10px !important;
  }

</style>


// WEBPACK FOOTER //
// src/views/account/supplier_invoice.vue